import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandListIcon} from "@pg-design/icons-module";
import {useUserDevice} from "@pg-mono/user-device";

import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {openAuthModal} from "../../auth/store/auth_modal_slice";
import {useAppDispatch} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {useGetIsUserAuthenticatedQuery} from "../../user/api/get_is_user_authenticated";

interface IProps {
    onButtonClick?: () => void;
}

export const VendorReportButton = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const dispatch = useAppDispatch();
    const {data: isUserAuthenticated} = useGetIsUserAuthenticatedQuery();

    const onClick = () => {
        props.onButtonClick?.();
        if (isUserAuthenticated) {
            //TODO vendor raport download.
            // It is probably worth adding an optional function (onSuccess: () => void;) to the modal state that will perform the download after logging in/registering.
            // Related task RP-27 Możliwość pobrania raportu o deweloperze
            console.log("Tu będzie pobranie raportu dla zalogowanego użytkownika");
        } else {
            dispatch(
                openAuthModal({
                    // TODO UserSource to fix in or after RP-30 Możliwość pobrania raportu o deweloperze [Analityka]
                    userSource: UserSource.REGISTER_PROPERTY_PLAN,
                    modalVariant: "download_raport",
                    headerVariant: AuthModalVariant.DOWNLOAD_RAPORT
                })
            );
        }
    };

    return (
        <Button className={buttonStyle} iconLeft={BrandListIcon} variant="brand_icon" size={isMobile ? "medium" : "big"} onClick={onClick}>
            Raport o deweloperze
        </Button>
    );
};

const buttonStyle = css({
    p: 0,
    mb: 2,
    mr: 2,

    md: {
        mb: 0,
        mr: 0
    }
});
import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandListIcon} from "@pg-design/icons-module";
import {useUserDevice} from "@pg-mono/user-device";

import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {openAuthModal} from "../../auth/store/auth_modal_slice";
import {useAppDispatch} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {useGetIsUserAuthenticatedQuery} from "../../user/api/get_is_user_authenticated";

interface IProps {
    onButtonClick?: () => void;
}

export const VendorReportButton = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const dispatch = useAppDispatch();
    const {data: isUserAuthenticated} = useGetIsUserAuthenticatedQuery();

    const onClick = () => {
        props.onButtonClick?.();
        if (isUserAuthenticated) {
            //TODO vendor raport download.
            // It is probably worth adding an optional function (onSuccess: () => void;) to the modal state that will perform the download after logging in/registering.
            // Related task RP-27 Możliwość pobrania raportu o deweloperze
            console.log("Tu będzie pobranie raportu dla zalogowanego użytkownika");
        } else {
            dispatch(
                openAuthModal({
                    // TODO UserSource to fix in or after RP-30 Możliwość pobrania raportu o deweloperze [Analityka]
                    userSource: UserSource.REGISTER_PROPERTY_PLAN,
                    modalVariant: "download_raport",
                    headerVariant: AuthModalVariant.DOWNLOAD_RAPORT
                })
            );
        }
    };

    return (
        <Button className={buttonStyle} iconLeft={BrandListIcon} variant="brand_icon" size={isMobile ? "medium" : "big"} onClick={onClick}>
            Raport o deweloperze
        </Button>
    );
};

const buttonStyle = css({
    p: 0,
    mb: 2,
    mr: 2,

    md: {
        mb: 0,
        mr: 0
    }
});
